module.exports = __webpack_public_path__ + "fonts/LibreFranklin-VariableFont_wght.99bb071f.ttf";